import { IDefaultOption } from 'components/common/select';
import { IAddress, ILogoData } from './common-interfaces';
import { IBrand, IEngine, ITireSize } from './vehicle-config-interfaces';
import { ICompanyDetails } from './company-interface';
import { IClientUserDetails } from './users-interface';

export interface IVehiclesFilters {
  organization_id: string[];
  company_id: string[];
  status: string;
  is_used: boolean;
  transmission: string[];
  category: string[];
  environmental_label: string[];
  engine_type: string[];
  fuel_type: string[];
  doors: number[];
  places: number[];
  tire_size: string[];
  start_km?: number;
  end_km?: number;
  registration_start_date: string;
  registration_end_date: string;
  purchase_start_date: string;
  purchase_end_date: string;
  is_new: boolean;
}
export interface IVehicleListItem {
  associatedCompany: ICompanyDetails;
  assigned_user_Id?: string;
  assigned_user_name?: string;
  brand_name: string;
  company_id: string;
  company_name: string;
  model: string;
  organization_id: string;
  organization_name: string;
  plate: string;
  purchase_date: string;
  registration_date: string;
  status: string;
  vehicle_image_url: string;
  _id: string;
  location: string[];
  totalPageCount: number;
}
export interface IVehicleDetails {
  _id: string;
  associatedCompany: ICompanyDetails;
  brand_data: IBrand;
  chasis: string;
  created_at: string;
  engine_data: IEngine;
  img_data: ILogoData | null;
  is_deleted: boolean;
  model: string;
  location: number[];
  // model_data: {
  //   _id: string;
  //   name: string;
  //   brand_id: string;
  //   asset_id: string;
  //   is_deleted: boolean;
  //   created_at: string;
  //   updated_at: string;
  // };
  organization: {
    _id: string;
    country_code: string;
    contact_us_url: string;
    created_at: string;
    email: string;
    fiscal_address: IAddress;
    fiscal_name: string;
    fiscal_number: string;
    is_deleted: boolean;
    mobile_no: string;
    organization_name: string;
    parking_ids: string[];
    updated_at: string;
    vat?: string;
  };
  parking: IAddress;
  past_user_ids: string[];
  plate: string;
  purchase_date: string;
  registration_date: string;
  status: string;
  front_tire_size_data: ITireSize;
  rear_tire_size_data: ITireSize;
  updated_at: string;
  user: {
    address: IAddress;
    billing_address: IAddress;
    birth_date: string;
    company_id: string;
    country_code: string;
    created_at: string;
    device_token: string;
    dni_exp_date: string;
    dni_no: string;
    email: string;
    is_deleted: boolean;
    license_exp_date: string;
    license_no: string;
    mobile_no: string;
    name: string;
    policy_exp_date: string;
    policy_no: string;
    surname: string;
    updated_at: string;
    _id: string;
  };
  vehicle_data: {
    category: string;
    created_at: string;
    doors: string;
    engine_id: string;
    environmental_label: string;
    fuel_type: string;
    is_used: boolean;
    km: number;
    last_updated_date?: string;
    last_workshop_km?: string;
    parking_id: string;
    places: string;
    tire_size_id: string;
    transmission: string;
    updated_at: string;
    vehicle_id: string;
    version?: string;
    _id: string;
    fuel_level?: {
      percentage: {
        value: number | null;
        last_updated_date: string | null;
        unit: string;
      };
      volume: {
        value: number | null;
        last_updated_date: string | null;
        unit: string;
      };
    };
    total_fuel_usage?: {
      value: number | null;
      last_updated_date: string | null;
      unit: string;
    };
    battery_level?: {
      value: number | null;
      last_updated_date: string | null;
      unit: string;
    };
    total_battery_usage?: {
      energy_out: number | null;
      energy_in: number | null;
      total_energy_used: number | null;
      unit: string;
      last_updated_date: string | null;
    };
  };
  vehicle_image_url: string;
  device_details: {
    _id: string;
    imeie: string;
    provider_id: string;
    is_deleted: boolean;
    created_at: string;
    updated_at: string;
  };
  provider_details: {
    _id: string;
    name: string;
    is_deleted: boolean;
    created_at: string;
    updated_at: string;
  };
  consumption?: {
    value: number | null;
    unit: string;
    distance_km: number | null;
    fuel_used_L: number | null;
    electric_used_kWh: number | null;
  };
  telemetry_period?: {
    filter: string;
    start: string;
    end: string;
    has_data: boolean;
    limited_data: boolean;
  };
}
export interface IVehicleAddEditData {
  _id: string;
  registration_date: string;
  purchase_date: string;
  organization: IDefaultOption | null;
  assignedUser: IDefaultOption | null;
  // model: IDefaultOption | null;
  model: string;
  brand: IDefaultOption | null;
  selectedParkingAddress: IAddress | null;
  associtedCompany?: IDefaultOption | null;
  category: IDefaultOption | null;
  plate: string;
  chasis: string;
  version: string;
  km?: string;
  doors?: string;
  places?: string;
  front_tire_size?: IDefaultOption | null;
  rear_tire_size?: IDefaultOption | null;
  engine?: IDefaultOption | null;
  status?: IDefaultOption | null;
  transmission: IDefaultOption | null;
  environmental_label: IDefaultOption | null;
  fuel_type: IDefaultOption | null;
  is_used?: string;
  device?: string;
  provider?: IDefaultOption | null;
}
export interface IVehicleErrors {
  model?: string;
  brand?: string;
  registration_date?: string;
  organization?: string;
  plate?: string;
  chasis?: string;
  engine_type?: string;
  front_tire_size?: string;
  rear_tire_size?: string;
  transmission?: string;
  provider: string;
  device: string;
  status?: string;
  km?: string;
  is_used?: string;

  // category?: string;
  // version?: string;
  // tuition?: string;
  // frame?: string;
  // fuel_type?: string;
  // type?: string;
}
export const initVehicleData: IVehicleAddEditData = {
  _id: '',
  registration_date: '',
  purchase_date: '',
  organization: null,
  assignedUser: null,
  // model: null,
  model: '',
  brand: null,
  category: null,
  chasis: '',
  environmental_label: { id: 'NONE', name: 'None', value: 'NONE' },
  plate: '',
  selectedParkingAddress: null,
  version: '',
  associtedCompany: null,
  doors: '',
  km: '',
  places: '',
  status: { id: 'ACTIVE', name: 'Active', value: 'Active' },
  front_tire_size: null,
  rear_tire_size: null,
  engine: null,
  transmission: null,
  fuel_type: null,
};
export interface IAddEditVehicleRequestBody {
  organization_id: string;
  vehicle_id?: string;
  user_id?: string;
  brand_id: string;
  model: string;
  registration_date: string;
  purchase_date?: string;
  status: string;
  plate: string;
  chasis: string;
  km: number;
  engine_id: string;
  fuel_type?: string;
  parking_id: string;
  environmental_label: string;
  transmission: string;
  is_used: boolean;
  associated_company?: string;
  doors?: string;
  places?: string;
  front_tire_size_id?: string;
  rear_tire_size_id?: string;
  tuition?: string;
  frame?: string;
  category?: string;
  version?: string;
  device_detail?: {
    provider_id: string;
    imeie: string;
  };
}

export interface IVehicleAlertItem {
  km_left: string;
  time_left_in_days: string;
  alert_ref: string;
  created_at: string;
  data: {
    vehicle_id: string;
  };
  description: string;
  from: string;
  is_deleted: boolean;
  is_read: boolean;
  notes?: string;
  status: string;
  title: string;
  to: string;
  type: string;
  updated_at: string;
  user_data: IClientUserDetails;
  alert_update_date: string;
  alert_update_km: string;
  _id: string;
}
